import { render } from "./DropDownMenuButton.vue?vue&type=template&id=389b5123&scoped=true"
import script from "./DropDownMenuButton.vue?vue&type=script&lang=js"
export * from "./DropDownMenuButton.vue?vue&type=script&lang=js"

import "./DropDownMenuButton.vue?vue&type=style&index=0&id=389b5123&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389b5123"]])

export default __exports__